import React from "react";
import _ from "underscore";
import moment from "moment";

import "./weatherChart.scss";

interface IWeatherChartProps extends React.Props<WeatherChart> {
  weatherData: ILocationWeatherByMonth;
  title?: string;
  height?: number;
}

export class WeatherChart extends React.Component<IWeatherChartProps, {}> {
  render() {
    var chartData = _.map(this.props.weatherData, (w, i) => {
      return {
        label: moment().month(parseInt(i) - 1).format("MMM").substr(0, 1),
        value: w.averageTemperature
      }
    });

    var maxValue = _.max(chartData, cd => cd.value);
    var minValue = _.min(chartData, cd => cd.value);
    var max = maxValue.value;
    var min = minValue.value;

    let dataCols = chartData.map((cData, index) => {
      var height = (((cData.value-min +6) / (max - min +6)) * 95);
      
      return (
        <div className="bar-chart-bar-wrapper" title={cData.label} key={`bar-${index}`}>
          <div className="bar-chart-bar" style={{ height: height + "%" }} title={`${cData.value}`}/>
        </div>
      );
    })

    return  <div className="bar-chart-container" style={{height: `${this.props.height ? `${this.props.height}px` : '100px'}`}}>
      {this.props.title && <div className="bar-chart-title">{this.props.title}</div> }
      <div className="bar-chart-wrapper">
      {dataCols}
      </div>
      </div>
  }
}